import type { ReactNode } from "react";

export type CardProps = {
    title?: string;
    eyebrow?: string;
    subtitle?: ReactNode;
    actions?: ReactNode;
    children?: ReactNode;
    footer?: ReactNode;
    className?: string;
};

export function Card({ title, eyebrow, subtitle, actions, children, footer, className = "" }: CardProps) {
    return (
        <div className={`rounded-2xl border border-white/10 bg-slate-950 shadow-xl ${className}`.trim()}>
            {(eyebrow || title || actions) ? (
                <div className="flex items-start justify-between gap-3 border-b border-white/10 px-4 py-3">
                    <div className="flex flex-col gap-1">
                        {eyebrow ? <span className="text-[11px] uppercase tracking-[0.18em] text-slate-400">{eyebrow}</span> : null}
                        {title ? <span className="text-sm font-semibold text-white">{title}</span> : null}
                        {subtitle ? <span className="text-xs text-slate-300">{subtitle}</span> : null}
                    </div>
                    {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
                </div>
            ) : null}
            <div className="px-4 py-3 text-sm text-slate-200">{children}</div>
            {footer ? <div className="border-t border-white/10 px-4 py-3 text-xs text-slate-300">{footer}</div> : null}
        </div>
    );
}
